import InputTypesEnum from '../../Enums/InputTypesEnum';
import dateTimeHelper from '../../Helpers/datetimeHelper';
import selectHelper from '../../Helpers/selectHelper';

class ReportingFilterParams {
  constructor() {
    this.initialize();
  }

  initialize() {
    this.UseActualMonth = true;
    this.StartDate = dateTimeHelper.firstDayOfTheActualMonth();
    this.EndDate = dateTimeHelper.lastDayOfTheActualMonth();
    this.Created = false;
    this.ClientConfirmed = true;
    this.OnField = true;
    this.OnHold = true;
    this.Closed = false;
    this.Cancelled = false;
    this.Status = ['ClientConfirmed', 'OnField', 'OnHold'];
    this.SelectedOfficeIds = [];
    this.ClientId = '';
    this.ServiceId = '';
    this.CountryId = '';
    this.AccountManagerId = '';
    this.SingleSearchLineText = '';
  }

  ClearAll() {
    this.initialize();
  }

  static title = 'Report Filter';
  static iconName = 'fa-solid fa-mug-hot';
  static saveType = 'PlanningReportingFilter';
  static startSearchButtonLabel = 'View on Screen';
  static startSearchButtonIconName = 'fa-solid fa-mug-hot';

  static getStatusesFunction() {
    return selectHelper.generateSelectValues([
      'Created',
      'ClientConfirmed',
      'OnField',
      'OnHold',
      'Closed',
      'Cancelled',
    ]);
  }

  static tabsOnTheSearchPanel = [
    { label: 'Filter', id: 'filter', icon: 'fa-solid fa-mug-hot' },
    { label: 'Advanced', id: 'advanced', icon: 'fa-solid fa-sliders' },
  ];

  static fieldsInSearchBox = [
    {
      fieldName: 'UseActualMonth',
      label: 'Use Actual Month',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
      tab: 'filter',
    },
    {
      fieldName: 'StartDate',
      label: 'Start Date',
      className: 'col-3',
      type: InputTypesEnum.Date,
      tab: 'filter',
      showCondition: (searchItem) => !searchItem.UseActualMonth,
    },
    {
      fieldName: 'EndDate',
      label: 'End Date',
      className: 'col-3',
      type: InputTypesEnum.Date,
      tab: 'filter',
      showCondition: (searchItem) => !searchItem.UseActualMonth,
    },
    {
      fieldName: 'Status',
      label: 'Status',
      className: 'col-3',
      type: InputTypesEnum.MultiChoice,
      tab: 'filter',
      options: ReportingFilterParams.getStatusesFunction(),
    },
    { fieldName: 'ClientId', label: 'Client', className: 'col-6', type: InputTypesEnum.ClientSelect, tab: 'advanced' },
    {
      fieldName: 'ServiceId',
      label: 'Service',
      className: 'col-6',
      type: InputTypesEnum.ServiceSelect,
      tab: 'advanced',
      idFilter: (searchItem) => searchItem.ClientId,
    },
    {
      fieldName: 'SelectedOfficeIds',
      label: 'Offices',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
      tab: 'advanced',
    },
    {
      fieldName: 'AccountManagerId',
      label: 'Account Manager',
      className: 'col-4',
      type: InputTypesEnum.UserSelect,
      tab: 'advanced',
    },
    {
      fieldName: 'CountryId',
      label: 'Country',
      className: 'col-4',
      type: InputTypesEnum.CountrySelect,
      tab: 'advanced',
    },
  ];

  static valuesToEraseOnChange = {
    values: [{ triggerField: 'ClientId', toErase: 'ServiceId', value: '' }],
  };

  static PrepareForBackend(searchItem) {
    const result = { ...searchItem };

    if (result.UseActualMonth) {
      result.StartDate = dateTimeHelper.firstDayOfTheActualMonth();
      result.EndDate = dateTimeHelper.lastDayOfTheActualMonth();
    }

    const selectedStatuses = Array.isArray(result.Status) ? result.Status : [];
    result.Created = selectedStatuses.includes('Created');
    result.ClientConfirmed = selectedStatuses.includes('ClientConfirmed');
    result.OnField = selectedStatuses.includes('OnField');
    result.OnHold = selectedStatuses.includes('OnHold');
    result.Closed = selectedStatuses.includes('Closed');
    result.Cancelled = selectedStatuses.includes('Cancelled');

    if (typeof result.ServiceId === 'string' && result.ServiceId.includes('//')) {
      result.ClientId = result.ServiceId.split('//')[1];
    }

    return result;
  }
}

export default ReportingFilterParams;
